module.exports = __webpack_public_path__ + "media/images/emblems/Daillens-coat_of_arms-afea763b05fb9794876cc17861a4b6b3.svg";